import { ForecastVersionStatus } from '@api-types/enums/forecast-version-status.enum';
import { Measure } from '@api-types/enums/measure.enum';
import { createReducer, on } from '@ngrx/store';
import { ForecastSeriesActions } from './forecast-series.actions';
import { ForecastSeriesState } from './forecast-series.state';

export const initialState: ForecastSeriesState = {
  isForecastSeriesFetching: false,
  isForecastSeriesUpdatePending: false,
  hasForecastSeriesFailedToFetch: false,
  latestForecastSeries: undefined,
  forecastSeriesError: undefined,
  progress: undefined,
  selectedFutureErrorMeasureValue: undefined,
  selectedFutureErrorMeasure: Measure.Wape,
  isFutureErrorMeasureCalculating: false,
};

export const forecastSeriesReducer = createReducer(
  initialState,
  on(
    ForecastSeriesActions.resetForecastSeries,
    (): ForecastSeriesState => initialState,
  ),
  on(
    ForecastSeriesActions.setIsForecastSeriesUpdatePending,
    (state, action): ForecastSeriesState => ({
      ...state,
      isForecastSeriesUpdatePending: action.isPending,
    }),
  ),
  on(
    ForecastSeriesActions.setIsForecastSeriesFetching,
    (state, { isFetching }): ForecastSeriesState => ({
      ...state,
      isForecastSeriesFetching: isFetching,
    }),
  ),
  on(ForecastSeriesActions.setForecastSeries, (state, res) => {
    const newState: ForecastSeriesState = {
      ...state,
      latestForecastSeries: res.forecastSeries,
      forecastSeriesError: res.forecastSeries
        ? undefined
        : state.forecastSeriesError,
    };
    return newState;
  }),
  on(
    ForecastSeriesActions.setUpdatedForecastSeries,
    (state, action): ForecastSeriesState => {
      if (!state.latestForecastSeries) {
        throw new Error('latestForecastSeries is undefined');
      }
      if (
        state.latestForecastSeries._resultSetStatus !==
        ForecastVersionStatus.FINISHED
      ) {
        throw new Error('latestForecastSeries is not finished');
      }
      // TODO fix this color Problem
      // const dataSeriesColors = this.colorService.getColors('filter');
      // const dataSeriesName = this.translateService.instant( 'RESULT.FILTER.AGGREGATE_NAME', );
      const newState: ForecastSeriesState = {
        ...state,
        latestForecastSeries: {
          ...state.latestForecastSeries,
          ...action.updatedForecastSeries,
          yAxis: action.updatedForecastSeries.yAxis
            ? action.updatedForecastSeries.yAxis
            : action.yAxisFallback,
          // colors: dataSeriesColors,
          // name: dataSeriesName,
        },
      };
      return newState;
    },
  ),
  on(
    ForecastSeriesActions.setForecastSeriesHasFailed,
    (state, action): ForecastSeriesState => ({
      ...state,
      hasForecastSeriesFailedToFetch: action.hasFailed,
    }),
  ),
  on(
    ForecastSeriesActions.setSelectedFutureErrorMeasureValue,
    (state, action): ForecastSeriesState => ({
      ...state,
      selectedFutureErrorMeasureValue: action.futureErrorMeasureValue,
    }),
  ),
  on(
    ForecastSeriesActions.setSelectedFutureErrorMeasure,
    (state, action): ForecastSeriesState => ({
      ...state,
      selectedFutureErrorMeasure: action.measureForFutureErrorMeasure,
    }),
  ),
  on(
    ForecastSeriesActions.setIsFutureErrorMeasureCalculating,
    (state, { isCalculating }): ForecastSeriesState => ({
      ...state,
      isFutureErrorMeasureCalculating: isCalculating,
    }),
  ),
);
